module.exports = __webpack_public_path__ + "static/media/Shari Nemerovski.644fdb83.png";